import { Box,Button,Flex,InputGroup,
  InputLeftElement,Input, Text,
  TableContainer,Table,Thead,Tbody,Th,Tr,Td } from "@chakra-ui/react";
import { TopDisplay } from "../../../../components";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState , useEffect} from "react";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import styled from "@emotion/styled";
import { atom, useAtom } from 'jotai';
import apiCall from '../../../../utils/apiCall';
import {TopLink} from '../';
import {openAtom,modalAtom,openNAtom,notificationAtom} from '../../../../context';
import {TablePopUp} from '../../../../components';
import { format } from "date-fns";
import { Loader } from "../../../../customs";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
}

const ROWSTYLE = styled.tr`
  & > td:last-of-type > *{
    display:none;
  }
  :hover > td{
    background-color:var(--table-highlight);
    &:last-of-type > *{
      display:block;
    }
  }
  &.active > td:last-of-type > *{
    display:block !important;
  }
`

const ExemptionStatusAtom = atom<number | null>(null);

export default function UpdateExemptionStatus() {
  const [active] = useAtom<number | string | null>(ExemptionStatusAtom);

  const itemsPerPage = 10;
  const [pageNumber,set_pageNumber] = useState(1);

  const {data:reset_data,isLoading} = useQuery(['student-exemption-status',pageNumber],{
    queryFn:async()=>await apiCall().get(`/Exam/GetStudentsforReset`,{params:{PageNumber:pageNumber,PageSize:itemsPerPage}}),
    keepPreviousData:true,
    select(data){
    return data.data;
    }
  });
  const all_student = reset_data?.students || [];
  const totalCount = reset_data?.TotalCount || 0;
  const pageCount = reset_data?.PageCount || 1;
  const [search,set_search] = useState('');
  const [filter_data,set_filter_data] = useState<any>(all_student);

  const handleSearch = (e:any)=>{
    let val = e.target.value;
    set_search(val);
    if(val){
      let new_data = all_student?.filter((eData:any) => Object.values(eData).join('').toLowerCase().includes(val.toLowerCase()) );
      if(new_data.length > 0)set_filter_data(new_data)
      else set_filter_data(all_student)
    }
    else set_filter_data(all_student)
  }

  const currentItems = filter_data;

  const handlePageClick = (event:any) => {
    set_pageNumber(event.selected + 1);
  };
  useEffect(()=>{
    set_filter_data(reset_data?.students || [])
  },[reset_data])

  return (
    <>
    {isLoading?<Loader />:
    <Box>
      <TopLink />
      <TopDisplay label="Update Exemption Status" />
        <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
          <span style={{position:'absolute',zIndex:'1',
          right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
          </InputGroup>
        </Flex>
        <Flex mt="25px" flexDir="column" gap="10px">
        <Text m="0" fontSize="1rem">All Students</Text>
          <Text m="0" fontSize=".8rem">Showing {all_student.length ? (pageNumber-1)*itemsPerPage+1 : 0} - {(pageNumber-1)*itemsPerPage + all_student.length} of {totalCount}</Text>
        </Flex>
     { filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
              <Tr >
                <Th sx={HeadStyle}>Student ID</Th>
                <Th sx={HeadStyle}>First Name</Th>
                <Th sx={HeadStyle}>Last Name</Th>
                <Th sx={HeadStyle}>Email</Th>
                <Th sx={HeadStyle}>Reset Date</Th>
                <Th sx={HeadStyle} w="50px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((eStudent:any,index:number) =><ROWSTYLE key={index} className={index === active?'active':''}>
                <Td sx={DataStyle}>{eStudent.StudentNo || 'N/A'}</Td>
                <Td sx={DataStyle}>{eStudent.FirstName}</Td>
                <Td sx={DataStyle}>{eStudent.LastName}</Td>
                <Td sx={DataStyle}>{eStudent.Email}</Td>
                <Td sx={DataStyle}>{format(new Date(eStudent.LastModified), "dd/MM/yyyy")}</Td>
                <Td sx={DataStyle} w="50px" h="50px">
                  <ExemptionStatusPopUp index={index} data={eStudent}/>
                </Td>
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :' Sorry No  student'
      }
      <StylePaginateBox>
      <ReactPaginate
        breakLabel="..."
        nextLabel=">"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel="<"
        forcePage={pageNumber-1}
        renderOnZeroPageCount={null}
      />

    </StylePaginateBox>

    </Box>
}
    </>

  )
}
const StylePaginateBox = styled.div`
width:100%;
& > ul{
  list-style-type: none;
  text-align:center;
  padding:0;
  margin:0;
  margin-top:10px;
}
& > ul > li{
  display: inline;
  margin:0 5px;
  padding:2px 5px;
  border-radius: 3px;
  background-color: transparent;
  color:var(--dark-green-color);
}
& > ul > li.selected{
  background-color: var(--highlight-paginate-background);
  color:var(--highlight-paginate-color);
}
& > ul > li:first-of-type,
& > ul > li:last-of-type{
  font-weight: bold;
}
`

const ExemptionStatusModal = (props:any) =>{
  const data = props.data;
  const queryClient = useQueryClient();
  const [,set_open] = useAtom(openAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);

  const { mutate: updateStatus, isLoading, variables:pendingValue } = useMutation({
    mutationKey: ['update-exemption-status'],
    mutationFn: async (hasPaid: boolean) => {
      return await apiCall().post(`/Exam/updateExemptionStatus`, {
        StudentNo: data.StudentNo,
        HasPaidExemptionFee: hasPaid,
      });
    },
    onSuccess: (response:any) => {
      set_notification({
        type: 'success',
        message: response?.data?.Message || 'Exemption Status Updated Successfully',
      });
      set_Nopen(true);
      queryClient.invalidateQueries(['student-exemption-status']);
    },
    onError: (error: any) => {
      set_notification({
        type: 'error',
        message: error?.response?.data?.Message || 'Error Occurred',
      });
      set_Nopen(true);
    },
    onSettled: () => {
      set_open(false);
    },
  });

  return (
    <Flex flexDir="column" align="center" gap="20px" minW="350px">
      <Text m="0" fontSize="1rem" textAlign="center">Has Student Paid Exemption Fee</Text>
      <Flex gap="20px" w="100%">
        <Button flex="1" disabled={isLoading} onClick={()=>updateStatus(true)} bg="var(--dark-green-color)" color="var(--white-color)">
          {isLoading && pendingValue === true ? 'Loading' : 'Yes'}
        </Button>
        <Button flex="1" disabled={isLoading} onClick={()=>updateStatus(false)} variant="outline" borderColor="var(--dark-green-color)" color="var(--dark-green-color)">
          {isLoading && pendingValue === false ? 'Loading' : 'No'}
        </Button>
      </Flex>
    </Flex>
  );
}

const ExemptionStatusPopUp = (props:any) =>{
  const index = props.index;
  const data = props.data;
  const [active,set_active] = useAtom(ExemptionStatusAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);

  const handleClick = () =>{
    if(index === active){
      set_active(null);
      return;
    }
    else{
      set_active(index);
    }
  }
  const handleUpdateExemption = () =>{
    set_modal({
      header:'Update Exemption Status',
      content:<ExemptionStatusModal data={data} />
    })
    set_open(true);
    handleClick();
  }

  return (
    <TablePopUp click={handleClick} options={[
      {label:'Update Exemption Status',click:handleUpdateExemption},
    ]} />
  )
}
